import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
    Box,
    Typography,
    CircularProgress,
    List,
    ListItem,
    ListItemText,
    Link,
} from '@mui/material';

function BillPublicPage() {
    const { state, year, bill_number } = useParams(); 
    const [loading, setLoading] = useState(true);
    const [bill, setBill] = useState(null);

    useEffect(() => {
        setLoading(true);  
        fetch(`${process.env.REACT_APP_API_URL}/bill-public/${state}/${year}/${bill_number}`, {
            method: 'GET',
            headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${process.env.REACT_APP_API_TOKEN}`,
            },
        })
            .then(res => res.json())
            .then(data => {
                setBill(data);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [state, year, bill_number]);

    return (
        <Box sx={{ padding: 3 }}>
            {loading ? (
                <Box display="flex" flexDirection="column" alignItems="center" mt={6}>
                    <CircularProgress size={50} />
                </Box>
            ) : bill ? (
                <>
                    <Typography variant="h5" gutterBottom>
                        {year} | {state} {bill_number} - {bill.title}
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom>
                        {bill.description}
                    </Typography>
                    {bill.url && (
                        <Box sx={{ my: 2 }}>
                            <iframe
                                src={
                                    window.location.origin.startsWith('http://localhost')
                                        ? bill.url.replace('https://api.civiclyenvolved.com', 'http://localhost:8000') || bill.url
                                        : bill.url
                                }
                                title="Bill Text"
                                width="100%"
                                height="600px"
                                style={{ border: '1px solid #ccc', borderRadius: 4 }}
                            />
                        </Box>
                    )}
                </>
            ) : (
                <Typography variant="h6" color="error">
                    Bill not found.
                </Typography>
            )}
        </Box>
    );
}

export default BillPublicPage;